import { type ButtonHTMLAttributes, forwardRef } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidth?: boolean;
  size?: ButtonSize;
  variant?: ButtonVariant;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, fullWidth = false, size = 'md', type = 'button', variant = 'primary', ...props },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      className={[
        'hotam-button',
        `hotam-button--${variant}`,
        `hotam-button--${size}`,
        fullWidth ? 'hotam-button--full' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  ),
);

Button.displayName = 'Button';
